import {connect} from 'react-redux';
import injectSheet from 'react-jss';

import ToastService from '-/services/ToastService';
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

const baseToast = {
    borderRadius: 4,
    display: 'flex',
    padding: 10,

    '& .close': {
        background: 'none',
        border: 'none',
        fontSize: '20px',
        width: '30px',
        textAlign: 'left',
        cursor: 'pointer'
    },
    '& .error': {
        flex: 1,
        fontSize: '16px'
    }
};

const styles = {
    holder: {
        margin: 10
    },
    toast_1: {
        ...baseToast,
        backgroundColor: '#f8d7da',
        border: 'solid 1px #f5c6cb',
        color: '#721c24'
    },
    toast_3: {
        ...baseToast,
        color: '#004085',
        backgroundColor: '#cce5ff',
        border: 'solid 1px #b8daff'
    },
    toast_2: {
        ...baseToast,
        color: '#155724',
        backgroundColor: '#d4edda',
        border: 'solid 1px #c3e6cb'
    },
    toast_0: {
        ...baseToast,
        color: '#856404',
        backgroundColor: '#fff3cd',
        border: 'solid 1px #ffeeba'
    }
};

const Toast = props => {
    const {classes, toasts} = props;

    return (
        <div className={classes.holder}>
            <ReactCSSTransitionGroup
                transitionName="toast-anim"
                transitionEnterTimeout={300}
                transitionLeaveTimeout={300}>
                {Object.keys(toasts).map(i => {
                    const toast = toasts[i];
                    const {type, id} = toast;

                    return (
                        <div key={i} className={classes[`toast_${type}`]} onClick={() => ToastService.removeToast(id)}>
                            <span onClick={() => ToastService.removeToast(id)} className="close">&times;</span>
                            {toast.content}
                        </div>
                    );
                })}
            </ReactCSSTransitionGroup>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        toasts: state.toasts
    };
};

export default connect(mapStateToProps, null)(injectSheet(styles)(Toast));
